import {register} from '@shopify/theme-sections';
import $ from 'jquery';


register('main-header', {
  onLoad() {
    this.$container = $(this.container);
    this.$navigation = $('#navigation');
    this.$filterStatusWrapper = $('.filter-status-wrapper');
    this.$collectionLinks = $('#collection-links');
    this.$sitewideBanner = $('#sitewide-banner');
    this.$couponBanner = $('#top-banner-container');
    this.namespace = `.${this.id}`;
    const self = this;

    $('#logout-link').on('click', (e) => {
      // On logout, remove both the recharge token and customer hash from the user's cookie.
      Cookies.remove('r_token');
      Cookies.remove('c_hash');
    });

    $('#navigation-links a').on('click', ({target}) => {
      const linkDest = target.getAttribute('href') || '';
      if (linkDest.includes('account/logout')) {
        // On logout, remove both the recharge token and customer hash from the user's cookie.
        Cookies.remove('r_token');
        Cookies.remove('c_hash');
      }
    });

    // 'MENU' BUTTON ON NAV - DESKTOP INTERACTIONS

    // Slide up the "meals" dropdown menu
    function slideUpMenu(linkClicked) {
      const associatedMenu = linkClicked.next();
      const associatedCarat = linkClicked.find('.navigation-links-dropdown-carat');

      associatedMenu.slideUp();
      associatedCarat.html('<i class="navigation-links-dropdown-carat-down fas fa-caret-down">');
    }

    function slideUpAllMenus() {
      $('.navigation-links-dropdown-link-list').slideUp();
      $('.navigation-links-dropdown-carat').html('<i class="navigation-links-dropdown-carat-down fas fa-caret-down">');
    }

    // Slide down the "meals" dropdown menu
    function slideDownMenu(linkClicked) {

      const associatedMenu = linkClicked.next();
      const associatedCarat = linkClicked.find('.navigation-links-dropdown-carat');

      associatedMenu.slideDown();
      associatedCarat.html('<i class="navigation-links-dropdown-carat-up fas fa-caret-up">');

    }

    function slideDownAllMenus() {
      $('.navigation-links-dropdown-link-list').slideDown();
      $('.navigation-links-dropdown-carat').html('<i class="navigation-links-dropdown-carat-up fas fa-caret-up">');
    }

    // Return true if the display is set to mobile mode (beyond 992px breakpoint); false if in desktop mode
    // Determine this by getting the "display" CSS property of the #navigation-fade div, which is set using media query breakpoints in our CSS file
    function displayIsDesktop() {
      return $('#navigation-fade').css('display') == 'none';
    }

    function getNavHeight() {
      const navElements = [self.$navigation, self.$filterStatusWrapper, self.$collectionLinks, self.$sitewideBanner, self.$couponBanner];

      return navElements.reduce((acc, el) => {
        if (el) {
          acc += el.outerHeight() || 0;
        }
        return acc;
      }, 0);
    }

    // When a navigation dropdown is clicked, either slide down or slide up the sub list, depending on current state
    $('.navigation-links-dropdown').on('click', (evt) => {
      evt.stopPropagation();
      const linkClicked = $(evt.currentTarget);
      const associatedMenu = linkClicked.next();

      if (associatedMenu.is(':visible')) {
        slideUpMenu(linkClicked);
      } else {
        slideUpAllMenus();
        slideDownMenu(linkClicked);
      }
    });

    // In desktop mode, slide up meals menu when somewhere else on the page is clicked.
    $('body').on('click', (evt) => {

      // If we are in desktop mode...
      if (displayIsDesktop()) {
        if (!($(evt.target).hasClass('navigation-links-dropdown'))) {
          slideUpAllMenus();
        }
      }
    });


    // MOBILE NAV EXPAND AND COLLAPSE ANIMATIONS
    // Expands and collapses mobile nav when the menu button is pressed

    // Expand the mobile nav when the 'mobile nav menu expand' button is clicked
    $('#mobile-nav-menu-expand').on('click', () => {
      slideDownAllMenus();
      $('#navigation-wrapper').addClass('fade-click');
      $('#navigation-links').css('transform', 'translateY(0)');
      $('#navigation-fade').css('opacity', '');
      $('#mobile-nav-menu-expand').hide();
      $('#mobile-nav-menu-collapse').show();
      $('#navigation').addClass('mobile-header-expanded');
    });

    // Collapse the mobile nav when the 'mobile nav menu collapse' button is clicked
    $('#mobile-nav-menu-collapse').on('click', () => {
      $('#navigation-wrapper').removeClass('fade-click');
      $('#navigation-links').css('transform', 'translateY(-100%)');
      $('#navigation-fade').css('opacity', '0');
      $('#mobile-nav-menu-expand').show();
      $('#mobile-nav-menu-collapse').hide();
      $('#navigation').removeClass('mobile-header-expanded');
    });

    $('#navigation-links a:not(.navigation-links-dropdown)').on('click', () => {
      if (displayIsDesktop()) { return; }
      $('#navigation-wrapper').removeClass('fade-click');
      $('#navigation-links').css('transform', 'translateY(-100%)');
      $('#navigation-fade').css('opacity', '0');
      $('#mobile-nav-menu-expand').show();
      $('#mobile-nav-menu-collapse').hide();
    });

    $('#navigation-fade').on('click', () => {
      $('#navigation-wrapper').removeClass('fade-click');
      $('#navigation-links').css('transform', 'translateY(-100%)');
      $('#navigation-fade').css('opacity', '0');
      $('#mobile-nav-menu-expand').show();
      $('#mobile-nav-menu-collapse').hide();
    });


    // MOBILE NAV WINDOW RESIZE BUG FIXES
    // Fixes some bugs that brok the mobile nav on window resize
    $(window).on('resize', () => {
      if (displayIsDesktop()) {
        $('#navigation-links').css('transform', 'translateY(0)');
        $('#navigation-fade').css('opacity', '');
        self.$navigation.removeClass('mobile-header-expanded');
        slideUpAllMenus();
      } else {
        $('#navigation-links').css('transform', 'translateY(-100%)');
        $('#navigation-fade').css('opacity', '0');
        $('#mobile-nav-menu-expand').show();
        $('#mobile-nav-menu-collapse').hide();
        self.$navigation.removeClass('mobile-header-expanded');
        slideUpAllMenus();
      }
    });


    // HEADER ANIMATION ON DESKTOP

    // Hide Header on on scroll down
    // And show a fixed header on sroll up

    let didScroll;
    let lastScrollTop = 0;
    const delta = 5;
    const breakRatio = 4;
    const navbarHeight = getNavHeight();
    let fading = false;

    $(window).on('scroll', () => {
      didScroll = true;
    });

    setInterval(() => {
      if (!didScroll) { return; }
      hasScrolled();
      didScroll = false;
    }, 0);

    function hasScrolled() {

      // If the display is mobile, only run these functions if the mobile header is not expanded
      if (displayIsDesktop() || !self.$navigation.hasClass('mobile-header-expanded')) {

        // Only run these functions if document is ready
        if (document.readyState === 'complete') {

          // Create a "st" variable to hold the current scroll position (top of page = 0)
          const st = $(document).scrollTop();

          // Don't trigger any more functions unless the gap between last scrolltop  and scrolltop is less than or equal to the delta
          if (Math.abs(lastScrollTop - st) <= delta) { return; }

          // If the user scrolled down...
          if (st > lastScrollTop) {

            // If the user is past the breakpoint, slide the nav up
            if (st > (navbarHeight * breakRatio)) {
              self.$navigation.addClass('nav-up');
              self.$filterStatusWrapper.removeClass('follow-nav');
              self.$collectionLinks.removeClass('follow-nav');
            }

          // If the user scrolled up...// If we are under the window breakpoint
          } else if (st < (navbarHeight * breakRatio)) {
            if (self.$navigation.hasClass('fixed')) {
              if (fading === false) {
                fading = true;
                self.$navigation.fadeOut(200, () => {
                  self.$navigation.removeClass('fixed');
                  self.$navigation.removeClass('nav-up');
                  self.$navigation.show();
                  fading = false;
                });
                self.$filterStatusWrapper.addClass('follow-nav');
                self.$collectionLinks.addClass('follow-nav');
              }
            } else if (self.$navigation.hasClass('nav-up')) {
              if (fading === false) {
                fading = true;
                self.$navigation.fadeOut(200, () => {
                  self.$navigation.removeClass('nav-up');
                  self.$navigation.show();
                  fading = false;
                });
                self.$filterStatusWrapper.addClass('follow-nav');
                self.$collectionLinks.addClass('follow-nav');
              }
            }
          } else {
            self.$navigation.removeClass('nav-up');
            self.$filterStatusWrapper.addClass('follow-nav');
            self.$collectionLinks.addClass('follow-nav');
            self.$navigation.addClass('fixed');
          }

          lastScrollTop = st;

        }
      }
    }
  },
});
